import { dataThumbUp } from 'dls-icons-data'
import { createIcon } from '../common'

const IconThumbUp = /*#__PURE__*/createIcon(dataThumbUp)
export default IconThumbUp
